angular.module('AccountingBoxApp')
    .controller('SalesViewCtrl', function($state,$scope, $stateParams,$location, $anchorScroll, Sale,LoopBackAuth) {
        var vm = this;
        var sales = Sale.find();
        vm.sales = sales;
        vm.detail = function(id) {
            vm.sale = Sale.get({
                'id': id
            });
            $state.go('app.company.sales.view',{id: id});
           //$state.go('app.company.sales.view', {id: id}, { location: true, inherit: true, relative: $state.$current, notify: false });
        };
        if ($stateParams.id) {
  			vm.sale = Sale.get({
                'id': $stateParams.id
            });
        	//vm.detail($stateParams.id);
		}
		vm.editSale = function(sale) {
        $state.go('app.company.edit.sales',{id:sale.id});
        };
             $scope.token = LoopBackAuth.accessTokenId;
    });
